import React from 'react';
import { FormattedMessage, FormattedPlural } from 'react-intl';

type SaveButtonProps = {
  resultsCount: number;
};

// TODO: DISCO-547 - We should use a common pattern to handle plurals
const SaveButton = ({ resultsCount }: SaveButtonProps) => <FormattedPlural one={<FormattedMessage defaultMessage="See {resultsCount} trail" values={{ resultsCount }} />} other={<FormattedMessage defaultMessage="See {resultsCount} trails" values={{ resultsCount }} />} value={resultsCount} />;

export default SaveButton;
